import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

export default function LeftColumn() {
  const { t } = useTranslation('calculator')
  const columnClass = classNames('flex', 'flex-col', 'gap-10')
  const titleClass = classNames(
    'text-2xl',
    'md:text-4xl',
    'font-bold',
    'text-white',
  )
  const textClass = classNames('text-lg', 'md:text-xl', 'text-white')

  const imageClass = classNames('w-[80%]', 'max-w-md', 'mx-auto')

  return (
    <div className={columnClass}>
      <h3 className={titleClass}>{t('calculator.leftColumn.title')}</h3>
      <p className={textClass}>{t('calculator.leftColumn.text')}</p>
      <img
        className={imageClass}
        src={`${process.env.REACT_APP_URL_S3}/images/calculator.png`}
        alt="layerBackground"
      />
    </div>
  )
}
